import { Reducer } from 'redux';
import Constants from '../constants';
import ContentConstants from '../contentConstants';
import { QuestionType } from '../models';
import { IQuestionQuery } from '../models/IQuestionQuery';
import * as Actions from './Actions';
import { ActionTypes } from './ActionTypes';

export interface ICustomQuestionModalState {
	activeContentId: number;
	customQuestionId?: number;
	isDemographic: boolean;
	isFollowUp: boolean;
	isOpen: boolean;
	parentQuestionId?: number;
	primaryButtonText?: string;
	secondaryButtonText?: string;
	title: string;
	warningModalOpen: boolean;
}

export const defaultState: ICustomQuestionModalState = {
	activeContentId: 1,
	isDemographic: false,
	isFollowUp: false,
	isOpen: false,
	title: '',
	warningModalOpen: false,
};

export const ActionCreators = {
	OpenCustomQuestionsModal: (query: IQuestionQuery) => (dispatch: any) => {
		dispatch({
			type: ActionTypes.CUSTOMQUESTIONS_MODAL_OPEN,
			payload: query,
		});
	},
	OpenCustomDemographicsQuestionModal: (query: IQuestionQuery) => (dispatch: any) => {
		dispatch({
			type: ActionTypes.CUSTOMDDEMOGRAPHICQUESTIONS_MODAL_OPEN,
			payload: query,
		});
	},
	AddOrEditCustomSurveyQuestion: (selectedQuestionQuestionId?: number) => (dispatch: any) => {
		dispatch({
			type: ActionTypes.CUSTOMQUESTIONS_MODAL_ADD_OR_EDIT_QUESTION,
			payload: { customQuestionId: selectedQuestionQuestionId },
		});
		if (!selectedQuestionQuestionId) {
			dispatch({
				type: ActionTypes.CUSTOM_QUESTION_RESPONSE_OPTIONS_GROUP_TAB_CHANGE,
				payload: { questionType: QuestionType.Scale, responseOptionsGroupTabKey: Constants.RESPONSE_OPTION_GROUP_TAB_STANDARD },
			});
		}
	},
	CancelAddOrEditCustomSurveyQuestion: () => {
		return { type: ActionTypes.CUSTOMQUESTIONS_MODAL_CANCEL_ADD_OR_EDIT_QUESTION };
	},
	ToggleCustomQuestionsModalWarningModal: (warningModalOpen: boolean) => (dispatch: any) => {
		dispatch({
			type: ActionTypes.CUSTOMQUESTIONS_MODAL_TOGGLE_WARNING_MODAL,
			payload: { warningModalOpen: warningModalOpen },
		});
	},
};

const getQuestionFormModalTitle = (isDemographic: boolean, customQuestionId?: number) => {
	if (isDemographic) {
		return customQuestionId ? ContentConstants.TITLE_UPDATE_DEMOGRAPHIC_QUESTION : ContentConstants.TITLE_CREATE_DEMOGRAPHIC_QUESTION;
	}

	return customQuestionId ? ContentConstants.TITLE_UPDATE_SURVEY_QUESTION : ContentConstants.TITLE_CREATE_SURVEY_QUESTION;
};

type KnownActions =
	| Actions.ICustomQuestionsModalOpen
	| Actions.ICustomQuestionsModalAddOrEditQuestion
	| Actions.ICustomQuestionsModalCancelAddOrEditQuestion
	| Actions.ICustomQuestionsModalToggleWarningModal
	| Actions.ICustomDemographicQuestionsModalOpen
	| Actions.ISurveyQuestionsModalSubmit;

export const reducer: Reducer<ICustomQuestionModalState, KnownActions> = (
	state: ICustomQuestionModalState = defaultState,
	action: KnownActions,
): ICustomQuestionModalState => {
	switch (action.type) {
		case ActionTypes.CUSTOMQUESTIONS_MODAL_OPEN:
			return {
				...state,
				...action.payload,
				isFollowUp: action.payload.parentQuestion !== undefined,
				parentQuestionId: action.payload.parentQuestion?.id,
				isOpen: true,
				secondaryButtonText: ContentConstants.BUTTONS_CLOSE,
				title: ContentConstants.TITLE_CUSTOM_SURVEY_QUESTIONS,
			};
		case ActionTypes.CUSTOMDDEMOGRAPHICQUESTIONS_MODAL_OPEN:
			return {
				...state,
				isOpen: true,
				title: ContentConstants.TITLE_CUSTOM_DEMOGRAPHIC_QUESTIONS,
				isDemographic: true,
				secondaryButtonText: ContentConstants.BUTTONS_CLOSE,
			};
		case ActionTypes.CUSTOMQUESTIONS_MODAL_ADD_OR_EDIT_QUESTION:
			return {
				...state,
				activeContentId: 2,
				customQuestionId: action.payload.customQuestionId,
				title: getQuestionFormModalTitle(state.isDemographic, action.payload.customQuestionId),
				secondaryButtonText: undefined,
			};
		case ActionTypes.CUSTOMQUESTIONS_MODAL_CANCEL_ADD_OR_EDIT_QUESTION:
			return {
				...state,
				activeContentId: 1,
				title: ContentConstants.TITLE_CUSTOM_SURVEY_QUESTIONS,
				secondaryButtonText: ContentConstants.BUTTONS_CLOSE,
			};
		case ActionTypes.CUSTOMQUESTIONS_MODAL_TOGGLE_WARNING_MODAL:
			return {
				...state,
				warningModalOpen: action.payload.warningModalOpen,
			};
		case ActionTypes.SURVEYQUESTIONS_MODAL_SUBMIT:
			return {
				...defaultState,
			};
	}

	return state;
};
